import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from '../../../models/dynamic-form/question-base';
import { QuestionControlService } from '../../../services/dynamic-form/question-control.service';
import { QuestionDictionary } from '../../../models/dynamic-form/QuestionDictionary';

@Component({
  selector: 'ff-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  providers: [QuestionControlService],
})
export class DynamicFormComponent implements OnInit {
  private _questions: QuestionBase<string>[] | null = [];

  @Input() set questions(
    value: QuestionBase<string>[] | QuestionDictionary<string> | null
  ) {
    if (Array.isArray(value)) {
      this._questions = [...value];
      this.form = this.qcs.toFormGroup(
        this.questions as QuestionBase<string>[]
      );
      this.selection.emit(this.form.value);
    } else {
      const questionsArray = Object.values(value as QuestionDictionary<string>);
      this._questions = [...questionsArray];
      this.form = this.qcs.toFormGroup(
        this.questions as QuestionBase<string>[]
      );
      this.selection.emit(this.form.value);
    }
  }

  @Input() isHorizontalForm: boolean = false;

  get questions(): QuestionBase<string>[] | QuestionDictionary<string> {
    return this._questions;
  }

  get questionsArray(): QuestionBase<string>[] {
    return this._questions;
  }

  @Input() validationMessage = false;
  form!: FormGroup;

  /**
   * Return the options updated each time the user check a radio button
   * @internal
   */
  @Output() selection = new EventEmitter<any[]>();

  /**
   * Returns the current valid state of the form
   */
  @Output() formValid = new EventEmitter<boolean>();

  constructor(private qcs: QuestionControlService) {}

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.questions as QuestionBase<string>[]);
  }

  onChange(formData) {
    this.selection.emit(formData);

    this.formValid.emit(this.form.valid);
  }
}
